/**
 * Web-app types.
 *
 * The data model itself lives in shared/domain.ts so the web app, the Expo app
 * and the licence server cannot drift apart. This file re-exports it and adds
 * the navigation enum, which is web-only.
 */

export type {
  Product, Client, Order, OrderItem, Language, DayKey,
} from './shared/domain';

export { DAY_KEYS } from './shared/domain';

export enum AppSection {
  DASHBOARD = 'DASHBOARD',
  COMMAND = 'COMMAND',
  PRODUCTS = 'PRODUCTS',
  CLIENTS = 'CLIENTS',
  HISTORY = 'HISTORY',
  ANALYTICS = 'ANALYTICS',
  SETTINGS = 'SETTINGS',
}
